import { render, staticRenderFns } from "./QType4Answer.vue?vue&type=template&id=f069f4d2&scoped=true&"
import script from "./QType4Answer.vue?vue&type=script&lang=js&"
export * from "./QType4Answer.vue?vue&type=script&lang=js&"
import style0 from "./QType4Answer.vue?vue&type=style&index=0&id=f069f4d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f069f4d2",
  null
  
)

export default component.exports